/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import moment from 'moment';
import {TSBemerkungScope} from './enums/TSBemerkungScope';
import {TSBemerkungSichtbarkeit} from './enums/TSBemerkungSichtbarkeit';
import TSAbstractBemerkungEntity from './TSAbstractBemerkungEntity';
import TSBenutzer from './TSBenutzer';
import {TSSerializable} from './TSSerializable';

export default class TSBenutzerBemerkung extends TSAbstractBemerkungEntity implements TSSerializable<TSBenutzerBemerkung> {

    private _besitzer: TSBenutzer | undefined;

    private _scope: TSBemerkungScope;

    private _sichtbarkeit: TSBemerkungSichtbarkeit

    public get besitzer(): TSBenutzer | undefined {
        return this._besitzer;
    }

    public set besitzer(value: TSBenutzer | undefined) {
        this._besitzer = value;
    }

    public get scope(): TSBemerkungScope {
        return this._scope;
    }

    public set scope(value: TSBemerkungScope) {
        this._scope = value;
    }

    public get sichtbarkeit(): TSBemerkungSichtbarkeit {
        return this._sichtbarkeit;
    }

    public set sichtbarkeit(value: TSBemerkungSichtbarkeit) {
        this._sichtbarkeit = value;
    }

    deserialize(restObject: any): TSBenutzerBemerkung {
        super.deserialize(restObject);
        this.scope = restObject.scope;
        this.sichtbarkeit = restObject.sichtbarkeit;
        this.besitzer = this.deserializeOrNull(restObject.besitzer, new TSBenutzer());

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        restObject.scope = this.scope;
        restObject.sichtbarkeit = this.sichtbarkeit;
        restObject.besitzer = this.serializeOrInit(this.besitzer, restObject.besitzer);
        return restObject;
    }

    public static getDeserializer = (benutzerBemerkung: any) => {
        return new TSBenutzerBemerkung().deserialize(benutzerBemerkung);
    };

    public static getSerializer = (benutzerBemerkung: any) => {
        return benutzerBemerkung.serialize(benutzerBemerkung);
    };

    public getBesitzerName(): string {
        if (this.besitzer && this.besitzer.getFullName()) {
            return this.besitzer.getFullName();
        }
        return ' '
    }

    getTimestampErstellt(): moment.Moment {
        if (this.timestampErstellt) {
            return this.timestampErstellt;
        }
        return moment();
    }

    getBemerkungScope(): TSBemerkungScope {
        return this.scope;
    }

    getBesitzer(): TSBenutzer | undefined {
        return this.besitzer;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSBenutzerBemerkung.ts